// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.saveCardFrom{
    display: flex !important;
    margin: 5px;
    margin-left: auto !important;
}

.cardFormDetails{
    position: relative;
}

.cardFormDetails span{
    width: 220px;
}

.cardFormDetails .mdi-account-edit{
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
}

.card-from-error-message{
    color: red;
    text-align: right;
    display:flex ;
    display: flex;
    align-items: flex-start;
    justify-content: end;
    position: relative;
}

.displayerror {
    margin-bottom: 0px !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/OrdersForMultipleAddress/CardFrom/CardForm.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,WAAW;IACX,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC","sourcesContent":[".saveCardFrom{\n    display: flex !important;\n    margin: 5px;\n    margin-left: auto !important;\n}\n\n.cardFormDetails{\n    position: relative;\n}\n\n.cardFormDetails span{\n    width: 220px;\n}\n\n.cardFormDetails .mdi-account-edit{\n    position: absolute;\n    top: 0;\n    right: 0;\n    width: 0;\n}\n\n.card-from-error-message{\n    color: red;\n    text-align: right;\n    display:flex ;\n    display: flex;\n    align-items: flex-start;\n    justify-content: end;\n    position: relative;\n}\n\n.displayerror {\n    margin-bottom: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
